<!--
Copyright 2025 Google LLC. This software is provided as-is, without warranty 
or representation for any use or purpose. Your use of it is subject to your 
agreement with Google.
-->
<mat-expansion-panel class="mat-elevation-z0" (opened)="onFUQOpen()" (closed)="onFUQClose()"
    [expanded]="showArrowUpIcon" hideToggle="true" *ngIf="shouldShowSuggestions" #fuqPanel >
    <mat-expansion-panel-header>
        <mat-panel-title> Response suggestions
            <mat-icon class="arrowIcon">{{showArrowUpIcon ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</mat-icon>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="suggestions-list" *ngIf="!isFuqResponseLoading">
        <div class="suggestion" *ngFor="let res of FUQResponse?.fuqs; let ind = index">
            <img src="../../assets/summarize_auto.png" alt="asco-thumbnail" [ngClass]="disableFuqs ? 'disable-summarize-auto' : 'summarize-auto'">
            <span [ngClass]="disableFuqs ? 'disableFuqPanel' : 'question'" (click)="onClickFUQ(res)">{{res}}</span>
        </div>
    </div>

    <div class="suggestions-list" *ngIf="isFuqResponseLoading">
        <div class="suggestion" *ngFor="let ind of expectedQuestionsIndices">
            <div class="avatar"></div>
            <div>
                <div class="line"></div>
                <div class="line-short"></div>
            </div>
        </div>
    </div>
    <div *ngIf="(!FUQResponse && FUQError) || FUQResponse=='undefined'">
        <span class="error-message"> {{FUQError}} </span>
    </div>
</mat-expansion-panel>